<template>
  <div class="app-wrapper">
    <Header :idle_time="idle_time" :isShow_idle="isShow_idle"></Header>
    <Sidebar></Sidebar>
    <Toolbar v-if="showToolbar" id="Toolbar" ref="Toolbar"></Toolbar>

    <div
      :style="'left:' + Sidebarwidth + 'px;'"
      class="content-box"
      id="content-box"
      :class="{ 'content-collapse': collapse }"
      ref="content"
    >
      <div ref="elscrollbar" class="app-content" id="app-content">
        <transition name="move" mode="out-in">
          <router-view
            id="content-router"
            class="content"
            :contentSize="contentSize"
          >
          </router-view>
        </transition>
        <template>
          <el-backtop class="backtop" :bottom="100" target=".app-content">
          </el-backtop>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Toolbar from './Toolbar.vue';
import Header from './Header.vue';
import Sidebar from './Sidebar.vue';
import Axios from '@/modules/FPKG-20000-Util/prototypes/axios';

export default {
  name: 'layout',
  data() {
    return {
      contentSize: { height: 0, width: 0 },
      tagsList: [],
      collapse: false,
      Sidebarwidth: 230,
      idle_time: null,
      init_sidebar_width: 230,
      Toolbar_height: 0,
      isShow_idle: true,
    };
  },
  watch: {
    getSidebarWidth(d) {
      if (d !== 0) {
        this.Sidebarwidth = d;
      }
    },
  },
  components: {
    Header,
    Sidebar,
    Toolbar,
  },
  computed: {
    getSidebarWidth() {
      return this.$store.state.getSidebar.width;
    },

    showToolbar() {
      const show =
        this.$route.meta.showToolbar === false
          ? this.$route.meta.showToolbar
          : true;
      return show;
    },
  },
  async created() {
    this.$bus.$on('PC_sidebar', (msg) => {
      this.collapse = msg;
    });
  },

  methods: {
    async Timing() {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const userAccount = user.p3_account.p3_ant_account;
      const accountList = user.p11_ttl_exclude_account;

      const found = accountList.find(
        (element) => element.p3_ant_account === userAccount,
      );
      if (found === undefined) {
        this.isShow_idle = true;

        const idle_time = Number(localStorage.getItem('idle_time'));
        if (idle_time > 0 && idle_time !== null) {
          // 取的儲存的時間
          const timestamp = Number(localStorage.getItem('timestamp'));
          // 現在的時間
          const now = new Date().getTime();
          const nowTime = Math.floor(now / 1000);
          // 現在的時間 - 儲存的時間 大於 閒置時間做登出
          const difference = nowTime - timestamp;
          // 剩餘時間
          this.idle_time = idle_time - difference;
          if (difference > idle_time) {
            const res = await this.$http.put('account/auth/logout');
            this.$router.push('/login');
          }
          // 登出頁不執行
          if (this.$route.path !== '/login') {
            setTimeout(() => {
              this.Timing();
            }, 1000);
          }
        }
      } else {
        this.isShow_idle = false;
      }
    },

    getScreen() {
      this.Toolbar_height = this.$refs.Toolbar
        ? this.$refs.Toolbar.$el.clientHeight
        : 0;
      const { content } = this.$refs;
      this.contentSize.height = content.clientHeight;
      this.contentSize.width = content.clientWidth;
      // this.contentSize.height =
      //   document.body.clientWidth > 478
      //     ? content.clientHeight - this.Toolbar_height - 1
      //     : content.clientHeight;
      // this.contentSize.width = content.clientWidth;
    },
    handleScroll() {
      try {
        const scrollTop = this.$refs.elscrollbar;
        this.$store.dispatch('scrollTop', scrollTop.wrap.scrollTop);
      } catch (error) {
        // console.error('scrollTop', error);
      }
    },
    stopBus() {
      this.$bus.$off('create');
      this.$bus.$off('save');
      this.$bus.$off('modify');
      this.$bus.$off('delete');
      this.$bus.$off('info');
      this.$bus.$off('search');
      this.$bus.$off('advSearch');
      this.$bus.$off('pager');
      this.$bus.$off('export');
      this.$bus.$off('saveAndGo');
      this.$bus.$off('keepCreate');
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getScreen);
  },
  mounted() {
    this.Timing();

    this.init_sidebar_width = this.$store.state.getSidebar.width;
    this.$nextTick(() => {
      this.getScreen();
      window.addEventListener('resize', this.getScreen);
    });

    // 監聽 下拉事件
    // window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeRouteEnter(to, from, next) {
    // 透過vm參數來拜訪vue
    next((vm) => {
      vm.getScreen();
    });
  },

  beforeRouteUpdate(to, from, next) {
    const needStopBus = to.path !== from.path;
    if (needStopBus) {
      this.stopBus();
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.stopBus();
    this.getScreen();

    next();
  },
};
</script>
<style lang="scss">
// 滾到置頂的按鈕
.backtop {
  width: 42px !important;
  height: 42px !important;
  // border: #009688 2px solid;
  // color: #009688 !important;
  // background: #3d3d3d !important;
  right: 31px !important;
}
// 手機板置頂按鈕 需要這css
.app-content {
  @media all and (max-width: 767px) {
    height: 100vh;
    overflow-x: hidden;
  }
}

.move-enter-active,
.move-leave-active {
  transition: opacity 0.5s;
}

.move-enter,
.move-leave {
  opacity: 0;
}
</style>


<style lang="scss" scoped>
@import './style/style';

.content-box {
  position: absolute;
  // 根據sidebar的寬度
  // left: $sidebar-width;
  right: 0;
  top: 151px;
  bottom: 0;
  // 把 overflow-y 隱藏
  overflow-y: auto;
  -webkit-transition: left 0.3s ease-in-out;
  transition: left 0.3s ease-in-out;
  background: #f6f5f1;

  @media all and (max-width: 767px) {
    top: 50px;
    left: 0px !important;
  }

  .content {
    // width: auto;
    // padding: 10px 20px;

    @media all and (max-width: 767px) {
      // left: 0px;
      // padding: 20px;
    }
  }
}

.content-collapse {
  left: $sidebar-collapsed-width;

  @media all and (max-width: 767px) {
    left: 0px;
  }
}
</style>
<style lang="scss" src="./style/index.scss"></style>
<style lang="scss" src="./style/_article-detail.scss"></style>
<style lang="scss" src="./style/element-variables.scss"></style>
